<template>
  <div v-if="getCurrency[currencyIN]">
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">Create InvestBox</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="panel panel-filled">
        <div class="panel-body">
          <form @submit.prevent="submit" class="form-horizontal">
            <h5>Notice</h5>
            <ul>
              <li>InvestBox can't modify, please make sure before create</li>
            </ul>
            <div class="form-group">
              <label for="type" class="col-xs-4 control-label">type</label>
              <div class="col-xs-8">
                <select class="form-control" v-model="type">
                  <option value="SWAPPING">SWAPPING</option>
                  <option value="STAKING">STAKING</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label for="Currency" class="col-xs-4 control-label"
                >currencyIN</label
              >
              <div class="col-xs-8">
                <select
                  id="currencyOUT"
                  v-model="currencyIN"
                  class="form-control"
                >
                  <option
                    class="coin"
                    v-for="c in getCurrency"
                    v-bind:key="c.id"
                    v-bind:value="c.coin"
                    >{{ c.coin }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-group">
              <label for="Currency" class="col-xs-4 control-label"
                >currencyOUT</label
              >
              <div class="col-xs-8">
                <select
                  id="currencyOUT"
                  v-model="currencyOUT"
                  class="form-control"
                >
                  <option
                    class="coin"
                    v-for="c in getCurrency"
                    v-bind:key="c.id"
                    v-bind:value="c.coin"
                    >{{ c.coin }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-group">
              <label for="ratio" class="col-xs-4 control-label">ratio</label>
              <div class="col-xs-8">
                <input
                  id="ratio"
                  type="number"
                  min="0"
                  step="0.00000001"
                  v-model="ratio"
                  class="form-control"
                  placeholder="IN:OUT"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="period" class="col-xs-4 control-label">period</label>
              <div class="col-xs-8">
                <input
                  id="period"
                  type="number"
                  min="0"
                  step="1"
                  v-model="period"
                  class="form-control"
                />
                <span class="unit">days</span>
              </div>
            </div>
            <div class="form-group">
              <label for="fee" class="col-xs-4 control-label">fee</label>
              <div class="col-xs-8">
                <input
                  id="fee"
                  type="number"
                  min="0"
                  step="0.00000001"
                  v-model="fee"
                  class="form-control"
                  placeholder="fees in %"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="com" class="col-xs-4 control-label">com</label>
              <div class="col-xs-8">
                <input
                  id="com"
                  type="number"
                  min="0"
                  step="0.00000001"
                  v-model="com"
                  class="form-control"
                  placeholder="commission in %"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="min_invest" class="col-xs-4 control-label"
                >min_invest</label
              >
              <div class="col-xs-8">
                <input
                  id="min_invest"
                  type="number"
                  min="0"
                  step="0.00000001"
                  v-model="min_invest"
                  class="form-control"
                />
                <span class="unit">{{ currencyIN }}</span>
              </div>
            </div>
            <div class="form-group">
              <label for="total" class="col-xs-4 control-label">total</label>
              <div class="col-xs-8">
                <input
                  id="total"
                  type="number"
                  min="0"
                  step="0.00000001"
                  v-model="total"
                  class="form-control"
                  placeholder="Total can invest "
                />
                <span class="unit">{{ currencyIN }}</span>
              </div>
            </div>
            <div class="text-center m-t-sm m-b-sm">
              <div v-if="total > 0">
                <!-- SWAPPING -->
                <div
                  class="text-center m-t-sm m-b-sm"
                  v-if="type == 'SWAPPING'"
                >
                  {{ $t("Swapping") }}
                  <span class="text-accent"
                    >{{ fixed(total) }} {{ currencyIN }}</span
                  >
                  {{ $t("toget") }}
                  <span class="text-accent">
                    {{ fixed(ratio * total) }}
                    {{ currencyOUT }}</span
                  >
                  {{ $t("in") }} {{ period }}
                  {{ $t("days") }}
                  <h3 class="font-bold" v-if="getCoins[currencyOUT]">
                    <span
                      class="text-buy "
                      v-if="
                        ((((ratio * getCoins[currencyOUT].last_price) /
                          getCoins[currencyIN].last_price -
                          1) *
                          100) /
                          period) *
                          365 >
                          0
                      "
                    >
                      +{{
                        usd(
                          ((((ratio * getCoins[currencyOUT].last_price) /
                            getCoins[currencyIN].last_price -
                            1) *
                            100) /
                            period) *
                            365
                        )
                      }}<small class="m-l-xs">%</small>
                    </span>
                    <span class="text-sell " v-else>
                      {{
                        usd(
                          ((((ratio * getCoins[currencyOUT].last_price) /
                            getCoins[currencyIN].last_price -
                            1) *
                            100) /
                            period) *
                            365
                        )
                      }}<small class="m-l-xs">%</small>
                    </span>
                  </h3>
                  <h3 class="text-buy font-bold" v-else>
                    {{ 0 }}<small class="m-l-xs">%</small>
                  </h3>
                  <p class="yield">Estimated Annual Yield</p>
                </div>

                <!-- STAKING -->
                <div class="text-center m-t-sm m-b-sm" v-if="type == 'STAKING'">
                  {{ $t("Staking") }}
                  <span class="text-accent"
                    >{{ fixed(total) }} {{ currencyIN }}</span
                  >
                  {{ $t("toearn") }}
                  <span class="text-accent"
                    >{{ ((ratio * total) / period).toLocaleString() }}
                    {{ currencyOUT }}</span
                  >
                  {{ $t("dailyrewards") }} ({{ $t("total") }}
                  {{ ratio * total }} {{ currencyOUT }})<br />
                  {{ $t("Capitalreturnafter") }} {{ period }}
                  {{ $t("days") }}
                  <h3 class="text-buy font-bold" v-if="getCoins[currencyOUT]">
                    {{
                      usd(
                        (getCoins[currencyOUT].last_price * 36500) /
                          ((period / ratio) * getCoins[currencyIN].last_price)
                      )
                    }}<small class="m-l-xs">%</small>
                  </h3>
                  <h3 class="text-buy font-bold" v-else>
                    {{ 0 }}<small class="m-l-xs">%</small>
                  </h3>
                  <p class="yield">Estimated Annual Yield</p>
                </div>
              </div>
            </div>
            <button
              v-if="loading"
              class="btn btn-default btn-block"
              disabled=" "
            >
              <i class="fad fa-spinner-third fa-spin m-r-xs"></i>Loading
            </button>
            <button
              v-else-if="
                !ratio || !period || !fee || !com || !min_invest || !total
              "
              class="btn btn-default btn-block"
              disabled=" "
            >
              Submit
            </button>
            <button v-else class="btn btn-accent btn-block text-accent">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nativeToast from "native-toast";
import investbox from "@/api/investbox";
import func from "@/widgets/func.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      type: "SWAPPING",
      currencyIN: "BTC",
      currencyOUT: "USDT",
      ratio: null,
      period: null,
      fee: null,
      com: null,
      min_invest: null,
      total: null,
      loading: false
    };
  },
  computed: mapGetters(["getCurrency", "getCoins"]),
  methods: {
    fixed(a) {
      return func.fixed(a);
    },
    usd(a) {
      return func.fixed2(a);
    },
    async submit() {
      this.loading = true;
      await investbox
        .create({
          currencyIN: this.currencyIN,
          currencyOUT: this.currencyOUT,
          ratio: this.ratio,
          period: this.period,
          fee: this.fee,
          com: this.com,
          min_invest: this.min_invest,
          total: this.total,
          type: this.type
        })
        .then(() => {
          this.loading = false;
          this.ratio = null;
          this.period = null;
          this.min_invest = null;
          this.total = null;
          nativeToast({
            message: "Successfully.",
            position: "top",
            timeout: 3000,
            type: "success"
          });
        })
        .catch(error => {
          this.loading = false;
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error"
          });
        });
    }
  }
};
</script>
